import { Box, Flex } from "@chakra-ui/react";
import JoinCard from "./JoinCard";
import Carousel from "./Carousel";
import distributorPartner from "../../assets/distributorPartner.svg";
import resellerPartner from "../../assets/resellerPartner.svg";
import { SlidersInterface } from "../../constants/Landing";

const PartnershipPromoSection = ({
  carouselData,
  isCarouselDataLoading,
}: {
  carouselData: SlidersInterface[] | undefined;
  isCarouselDataLoading: boolean;
}) => {
  const partnershipData = [
    {
      title: "Reseller",
      description:
        "Apakah Anda ingin memulai bisnis dengan modal minim dan keuntungan maksimal? Bergabunglah bersama kami sebagai Reseller! Nikmati peluang besar untuk menjual produk berkualitas dan mendapatkan penghasilan tambahan tanpa repot.",
      image: resellerPartner,
      role: 2,
    },
    {
      title: "Supplier",
      description:
        "Ingin produk Anda dikenal lebih luas dan menjangkau pasar yang lebih besar? Bergabunglah sebagai Supplier kami! Dengan jaringan luas dan dukungan pemasaran yang profesional, kami siap membantu Anda memasarkan produk kepada pelanggan di seluruh Indonesia",
      image: distributorPartner,
      role: 3,
    },
  ];

  return (
    <Box>
      {carouselData && (
        <Carousel
          carouselData={carouselData}
          isCarouselDataLoading={isCarouselDataLoading}
        />
      )}

      <Flex
        direction={{ base: "column", lg: "row" }}
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={{ base: "40px" }}
        mt={{ base: "26px", xl: "40px" }}
      >
        {partnershipData?.map((partner, index) => (
          <JoinCard
            key={index}
            title={partner?.title}
            image={partner?.image}
            description={partner?.description}
            role={partner?.role}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default PartnershipPromoSection;
